/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ExportTargetMappingIndexQueryParams,
	ExportTargetMappingIndexResponse,
} from '../types/ExportTargetMappingIndex'

/**
 * GET /export-target-mappings
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::index
 */
export async function exportTargetMappingIndex(
	params?: ExportTargetMappingIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportTargetMappingIndexResponse>> {
	return axiosInstance.get('/export-target-mappings', { params, ...config })
}
